import { Lightbulb, Wand2, Camera, Rocket, ArrowRight } from "lucide-react";

const steps = [
  {
    icon: Lightbulb,
    title: "Idee & Briefing",
    body: "Gemeinsam mit dir: Zielgruppe, Tonality, Plattform, Deadline. Ich übersetze dein Briefing in einen klaren Output-Plan.",
    color: "hsl(45, 95%, 60%)",
  },
  {
    icon: Wand2,
    title: "KI-Agenten arbeiten",
    body: "Freycreate startet. Creative-Agent generiert Visuals & Hooks. Research liefert Marktdaten. Planning baut die Edit-Sequenz. Coding sorgt für Format-Anpassungen. Testing prüft Output-Qualität.",
    color: "hsl(280, 75%, 65%)",
  },
  {
    icon: Camera,
    title: "Kennys Schliff",
    body: "Ich kuratiere, ergänze klassischen Cinema-Shot wo nötig, baue echte Drehorte in den Cut. KI + Menschenhand.",
    color: "hsl(200, 85%, 60%)",
  },
  {
    icon: Rocket,
    title: "Lieferung & Optimierung",
    body: "Mehrere Plattform-Cuts (16:9 / 9:16 / 1:1) plus optionale Variants für A/B-Tests. Iteration nach Daten.",
    color: "hsl(160, 75%, 55%)",
  },
];

const AiProcess = () => (
  <section className="py-16 sm:py-24 bg-secondary/20" data-testid="ai-process">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[hsl(var(--accent))]/10 border border-[hsl(var(--accent))]/30 text-[hsl(var(--accent))] text-xs font-semibold uppercase tracking-widest mb-4">
          Workflow
        </div>
        <h2 className="text-3xl sm:text-5xl font-bold mb-4">Vom Briefing zum fertigen Spot</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          4 Schritte, in denen Mensch und KI sich gegenseitig multiplizieren.
        </p>
      </div>

      {/* Steps */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-6xl mx-auto">
        {steps.map((step, i) => {
          const Icon = step.icon;
          return (
            <div key={i} className="relative group">
              <div className="h-full bg-background/60 border border-white/5 rounded-2xl p-6 hover:border-[hsl(var(--accent))]/40 transition-all">
                {/* Step number */}
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-3">
                  Schritt {i + 1}
                </div>
                {/* Icon */}
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 border"
                  style={{
                    backgroundColor: `${step.color}20`,
                    borderColor: `${step.color}66`,
                  }}
                >
                  <Icon className="w-6 h-6" style={{ color: step.color }} />
                </div>
                <h3 className="text-lg font-bold mb-2">{step.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{step.body}</p>
              </div>

              {/* Arrow connector (desktop only, between cards) */}
              {i < steps.length - 1 && (
                <div className="hidden lg:flex absolute top-1/2 -right-4 -translate-y-1/2 z-10 items-center justify-center w-8 h-8 rounded-full bg-background border border-[hsl(var(--accent))]/40">
                  <ArrowRight className="w-4 h-4 text-[hsl(var(--accent))]" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default AiProcess;
